<template>
  <div class="home">
    <div>{{ errorMsg }}</div>
    <CloudTags></CloudTags>
    <Navigation
      :displayMode="displayMode"
      @changeDisplayMode="changeDisplayMode"
      ></Navigation>

    <Pagination></Pagination>

    <div class="bookmarks" :class="displayMode">
      <Bookmark
        v-for="bookmark in bookmarks"
        :key="bookmark.id"
        :bookmark="bookmark"
      ></Bookmark>
    </div>

    <Pagination></Pagination>
  </div>
</template>

<script>
// @ is an alias to /src
import { Component, Prop, Vue } from 'vue-property-decorator'
import Bookmark from '@/components/Bookmark'
import CloudTags from '@/components/CloudTags'
import Navigation from '@/components/Navigation'
import Pagination from '@/components/common/Pagination'

@Component({
  name: 'Home',
  props: ['id', 'tags', 'fulltext', 'query', 'orderby', 'orderasc', 'first'],
  components: {
    CloudTags,
    Bookmark,
    Navigation,
    Pagination
  }
})
class Home extends Vue {
  @Prop id
  @Prop tags
  @Prop fulltext
  @Prop query
  @Prop orderby
  @Prop orderasc
  @Prop first

  mTags = this.forceArrayTags(this.tags)
  mFulltext = this.fulltext || ''
  mQuery = this.query || ''
  mOrderby = this.orderby || ''
  mOrderasc = this.orderasc || false
  mFirst = this.first || 0

  displayMode = 'list'
  errorMsg = ''

  get bookmarks() {
    return this.queryResult
  }

  forceArrayTags(tags) {
    if (!tags) {
      return []
    }

    return Array.isArray(tags) ? [...tags] : tags.split(/[\s,;]+/)
  }

  fetchBookmark() {
    let searchParams = new URLSearchParams()
    this.id && searchParams.append('id', this.id)
    this.mTags && this.mTags.forEach((t) => searchParams.append('tags', t))
    this.mFulltext && searchParams.append('fulltext', this.mFulltext)
    this.mQuery && searchParams.append('query', this.mQuery)
    this.mOrderby && searchParams.append('orderby', this.mOrderby)
    this.mOrderasc && searchParams.append('orderasc', this.mOrderasc)
    this.mFirst && searchParams.append('first', this.mFirst)

    this.$fetch.get(`/bookmarks?${searchParams.toString()}`).then(
      (data) => {
        this.$store.commit('query', data)
      },
      (err) => {
        this.errorMsg = err.cause
      }
    )
  }

  changeDisplayMode(mode) {
    this.displayMode = mode
  }

  beforeMount() {
    console.log('beforeMounted home')
    this.fetchBookmark()
  }
}

export default Home
</script>

<style scoped lang="less">
@import '../assets/less/globals';

.home {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bookmarks{
  width: 100%;
  max-width: calc(1200px + 2 * var(--margin--medium));

  margin-top: var(--margin--small);
  padding-left: var(--margin--medium);
  padding-right: var(--margin--medium);
}

.bookmarks.grid {
  display: grid;

  grid-gap: var(--margin--large);
  grid-template-columns: 100%;
}

@media screen and (min-width: @screen-desktop-low) {
  .bookmarks.grid {
  /* FIXME LK : Check Browsers comptability */
    grid-template-columns: repeat(
      auto-fill,
      minmax(var(--grid-display-mode-bookmark-width), 1fr)
    );
    grid-template-rows: repeat(
      auto-fill,
      400px
    );
    margin-bottom: var(--margin---small);
    overflow-y: auto;
  }
}
</style>
